import React from 'react';
import { useMediaQuery } from '@mui/material';
import workout1 from '../../Assets/images/Services/workout1.jpeg';
import workout2 from '../../Assets/images/Services/workout2.jpeg';
import workout3 from '../../Assets/images/Services/workout3.jpeg';
import workout4 from '../../Assets/images/Services/workout4.jpeg';

const services = [
  {
    title: 'XFit',
    description:
      'Unlock your full potential with our XFit program. Our expert coaches will guide you through a series of high-intensity workouts designed to improve your strength, endurance, and agility.',
    image: workout1,
    benefits: ['Improved endurance', 'Increased strength', 'Weight loss']
  },
  {
    title: 'Personal Training',
    image: workout2,
    description:
      'Take your fitness journey to the next level with our personalized training programs. Our experienced trainers will create a customized fitness plan tailored to your needs.',
    benefits: ['Personalized guidance', 'Faster results', 'Motivation']
  },
  {
    title: 'Beach Bootcamps',
    image: workout3,
    description:
      'Get fit and have fun with our beach bootcamps! Our expert trainers will lead you through high-energy workouts designed to challenge and motivate you.',
    benefits: ['Fun environment', 'Cardio boost', 'Strength training']
  },
  {
    title: 'Aquatic Fitness',
    image: workout4,
    description:
      'Make a splash with our aquatic fitness programs! Our expert instructors guide you through low-impact, high-intensity workouts in a relaxing water-based environment.',
    benefits: ['Joint-friendly', 'Increased flexibility', 'Muscle toning']
  }
];

// Styles
const styles = {
  pageContainer: {
    padding: '20px',
    backgroundColor: 'black',
    color: 'white',
    minHeight: '100vh'
  },
  pageTitle: {
    color: '#00eaff',
    textAlign: 'center',
    marginBottom: '20px'
  },
  cardsContainer: (isMobile) => ({
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', // 1 card per row on mobile, 2 per row otherwise
    gap: '20px',
    justifyContent: 'center'
  }),
  card: {
    backgroundColor: '#333',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    color: 'white',
    padding: '20px',
    textAlign: 'left',
    boxSizing: 'border-box'
  },
  cardImage: {
    width: '100%',
    borderRadius: '10px',
    marginBottom: '15px'
  },
  cardTitle: {
    fontSize: '1.5em',
    marginBottom: '10px'
  },
  cardDescription: {
    fontSize: '1em',
    marginBottom: '15px'
  },
  benefitsTitle: {
    fontSize: '1.2em',
    marginBottom: '10px'
  },
  benefitsList: {
    listStyleType: 'disc',
    margin: 0,
    padding: '0 20px'
  },
  benefitsItem: {
    marginBottom: '5px'
  }
};

// Main Component
const Services = () => {
  const isMobile = useMediaQuery('(max-width:768px)'); // Check screen size

  return (
    <div id="services-section" style={styles.pageContainer}>
      <h1 style={styles.pageTitle}>Our Services</h1>
      <div style={styles.cardsContainer(isMobile)}>
        {services.map((service, index) => (
          <div key={index} style={styles.card}>
            <h2 style={styles.cardTitle}>{service.title}</h2>
            <p style={styles.cardDescription}>{service.description}</p>
            <h3 style={styles.benefitsTitle}>Benefits:</h3>
            <ul style={styles.benefitsList}>
              {service.benefits.map((benefit, i) => (
                <li key={i} style={styles.benefitsItem}>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
